import { PureLightTheme } from "../../styles/theme"
import { mobileBottomInsetBrowser, mobileBottomInsetPwa } from "../../consts/mobileLayout"

export const StyledBox = {
  minHeight: '100%',
  position: 'relative',
}

export const PagesBox = {
  minWidth: 0,
  width: '100%',
  marginTop: '61px',
  marginBottom: '16px',
  minHeight: 'calc(100vh - 61px - 16px)',
  [PureLightTheme.breakpoints.down('md')]: {
    marginBottom: `calc(${mobileBottomInsetBrowser})`,
    minHeight: `calc(100vh - 61px - (${mobileBottomInsetBrowser}))`,
  },
}

export const pagesBoxPwaSx = {
  [PureLightTheme.breakpoints.down('md')]: {
    marginBottom: `calc(${mobileBottomInsetPwa})`,
    minHeight: `calc(100vh - 61px - (${mobileBottomInsetPwa}))`,
  },
} as const

export const StyledContainer = {
  minWidth: 0,
  maxWidth: '1860px',
  height: '100%',
}
